var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('back-to-top-button');
import { breakpoints } from '@shapeable/theme';
import { Button } from './button';
import { useLang } from '../hooks/use-lang';
import { DottedChevronUpIconGlyph } from '@shapeable/icons';
export var BackToTopButtonDefaultProps = {
  label: 'Back To Top',
  icon: DottedChevronUpIconGlyph
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var BackToTopButton = function (props) {
  var className = props.className,
    label = props.label,
    icon = props.icon;
  var t = useLang();
  var onClick = function (event) {
    event.stopPropagation();
    window.scrollTo(0, 0);
  };
  return React.createElement(My.Container, {
    onClick: onClick,
    icon: icon,
    className: className
  }, t(label));
};
BackToTopButton.defaultProps = BackToTopButtonDefaultProps;
BackToTopButton.cls = cls;
var templateObject_1, templateObject_2;